/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:04]
Permissions to update outside the main branch: [false]
*/

import { Input, toInt, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { Procedure } from 'models/api/procedure';
import { TariffProcedureParamsFilter as FilterType } from 'models/api/tariffProcedureParam';
import { FormGroup } from 'reactstrap';

type TariffProcedureParamsFilterParams = {
    procedures: Procedure[];
};

const TariffProcedureParamsFilter = ({ procedures }: TariffProcedureParamsFilterParams) => {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<FilterType>();
    return (
        <>
            <FormGroup>
                <Input
                    id="tpp-filter-name"
                    value={draftFilter.name || ''}
                    onChange={(e) => {
                        setDraftFilter((prevState) => ({ ...prevState, name: e.target.value }));
                    }}
                    label={t('BackOfficeName')}
                />
            </FormGroup>
            <FormGroup>
                <Input
                    type="select"
                    id="tpp-filter-procedure-name"
                    value={draftFilter.procedureId || ''}
                    onChange={(e) => {
                        setDraftFilter((prevState) => ({
                            ...prevState,
                            procedureId: toInt(e.target.value),
                        }));
                    }}
                    label={t('BackOfficeProcedureName')}
                    options={[<option key="-1" value="" />].concat(
                        procedures.map((i) => (
                            <option value={i.id} key={i.id}>
                                {i.name}
                            </option>
                        ))
                    )}
                />
            </FormGroup>
        </>
    );
};

export default TariffProcedureParamsFilter;
